import React from 'react'
import { Paper, Box, makeStyles } from '@material-ui/core'

const CustomBox = ({ children }) => {
  const classes = useStyles()
  return (
    <Paper elevation={3} className={classes.classes}>
      <Box px={3} py={1}>
        {children}
      </Box>
    </Paper>
  )
}

export default CustomBox

const useStyles = makeStyles({
  mainCard: {
    borderRadius: '12px',
    boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
    overflow: 'hidden',
    transition: 'all 0.3s ease-in-out'
  }
})
